<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-edit-address"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body pb-4">
                    <FormAddress
                        ref="form-address"
                        :address="addressModel"
                    ></FormAddress>
                </div>
                <div class="modal-base-footer">
                    <button
                        class="btn btn-secondary mr-2"
                        @click="clickCancel()"
                    >
                        Cancel
                    </button>
                    <button class="btn btn-primary" @click="clickSave()">
                        Save
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
// import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import FormAddress from "@/module/Address/DeliveryAddress/component/FormAddress.vue";
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "EditAddressModal",
    mixins: [ErrorApiMixin],
    components: {
        FormAddress
    },
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            busModal: null,
            lbl: Locale.getLbl(),

            addressModel: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden();
        },
        show: function() {
            this.addressModel = this.controller.address;
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },

        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        clickSave: function() {
            var addressModel = this.$refs["form-address"].submitForm();
            if (addressModel != null) {
                let token = Account.getToken();
                let params = addressModel.getParams();

                this.controller.loadingModal.show();
                BzbsAddressList.apiUpdateAddress(token, params).subscribe(
                    data => {
                        this.controller.loadingModal.hide();
                        this.saveSuccess(data);
                    },
                    err => {
                        this.controller.loadingModal.hide();
                        this.errorResponse(err);
                    }
                );
            }
        },

        saveSuccess: function(address) {
            this.hide();
            this.controller.sendCallbackEditSuccess(address);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
.modal-edit-address {
    @extend %modal-base;
}
</style>
